import React from "react";
import useStyles from "./TruncateText.style";

export const TruncateText = ({ text, lineClamp = 2 }: { text: string, lineClamp?: number }) => {
  const c = useStyles({ lineClamp });
  return (
    <span className={c.root}>
      {text}
    </span>
  );
};